import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Star } from "lucide-react";

const HIDDEN_PATHS = ["/sprava", "/prihlaseni", "/registrace", "/vstup", "/pokladna", "/kosik"];
const SHOW_PATHS = ["/kategorie", "/produkt", "/konfigurator"];
const IDLE_TIMEOUT = 4000; // hide after 4s of no mouse movement

export default function FveFloatingButton() {
    const { pathname } = useLocation();
    const [visible, setVisible] = useState(false);
    const [shown, setShown] = useState(false);
    const idleTimer = useRef(null);
    const entryTimer = useRef(null);

    const isHidden = HIDDEN_PATHS.some(p => pathname.startsWith(p));
    const isRelevant = pathname === "/" || SHOW_PATHS.some(p => pathname.startsWith(p));

    useEffect(() => {
        if (isHidden || !isRelevant) { setVisible(false); setShown(false); return; }

        const handleMouseMove = () => {
            if (!shown) {
                // First show after initial 3s delay
                if (!entryTimer.current) {
                    entryTimer.current = setTimeout(() => { setShown(true); setVisible(true); }, 3000);
                }
                return;
            }
            // Already shown before – show immediately on movement
            setVisible(true);
            clearTimeout(idleTimer.current);
            idleTimer.current = setTimeout(() => setVisible(false), IDLE_TIMEOUT);
        };

        window.addEventListener("mousemove", handleMouseMove);
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            clearTimeout(idleTimer.current);
            clearTimeout(entryTimer.current);
            entryTimer.current = null;
        };
    }, [pathname, isHidden, isRelevant, shown]);

    // After first appearance, start idle timer
    useEffect(() => {
        if (shown && visible) {
            clearTimeout(idleTimer.current);
            idleTimer.current = setTimeout(() => setVisible(false), IDLE_TIMEOUT);
        }
        return () => clearTimeout(idleTimer.current);
    }, [shown, visible]);

    if (!visible) return null;

    return (
        <Link to="/konfigurator"
            className="fixed bottom-[88px] right-5 z-[300] flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full shadow-xl border-2 border-yellow-400 hover:shadow-2xl hover:scale-105 transition-all duration-300 group animate-in fade-in slide-in-from-right-4"
            style={{ background: "var(--sg-primary, #2e7d32)" }}
            data-testid="fve-floating-button">
            <Star size={18} className="text-yellow-400 group-hover:rotate-12 transition-transform" fill="currentColor" />
            <span className="text-white font-bold text-sm whitespace-nowrap">FVE Konfigurator</span>
        </Link>
    );
}
